import { CondicaoCampoDTO } from "@/types/conclusao.type";

/**
 * Avalia a condição `exibirSe` de um campo de conclusão contra o valor atual do
 * campo de referência. Compartilhado entre o renderizador (oculta o campo) e o
 * cálculo de pendências (um campo oculto não conta como obrigatório).
 */
export function condicaoSatisfeita(cond: CondicaoCampoDTO, valor: unknown): boolean {
  const preenchido = valor !== undefined && valor !== null && valor !== "";
  switch (cond.operador) {
    case "PREENCHIDO":
      return preenchido;
    case "VAZIO":
      return !preenchido;
    case "IGUAL":
      return valor === cond.valor;
    case "DIFERENTE":
      return valor !== cond.valor;
    default:
      return true;
  }
}
